import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import * as fileSaver from 'file-saver';

import { environment } from '../../environments/environment';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';


@Injectable()
export class DownloadService {

  constructor(
    private http: HttpClient,
  ) { }


  downloadSecureFile(fileId, type='zip', filename = undefined) {
    let contentType = "application/zip";
    if(type=='xlsx') {contentType = "application/xlsx";}
    if (!filename){
      filename = `${fileId}.${type}`
    }
    if (type=='zip'){
      try{
        filename = fileId.split('.zip')[0];
        filename = filename.split('/').pop();
      }
      catch (error){
        console.log(error)
      }
    }
    return this.http.get(environment.rest_heart_service + fileId + '/secure/binary', { responseType: 'blob'})
    .pipe(
      map((response: any) => {
        const blob = new Blob([response], { type: contentType  });
        fileSaver.saveAs(blob, filename);
        return true;
      }),
      catchError((err: any) => {
        console.log('err--------', err);
       // Return false in case of error
       return of(false)
      })
    )
  }

}
